import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './case.routes';
import Response from './response';
import FillSubCase from './fillSubCase';
import AuthorizationForm from './authorization-form';

export default angular
  .module('verifyApp.public.case', [
    uiRouter, Response, AuthorizationForm, FillSubCase,
  ])
  .config(routing)
  .name;



// WEBPACK FOOTER //
// ./client/app/public/case/index.js